import React from 'react';
import './CheckboxListItem.less';
import { getLightBrandColor } from 'getaway-data-layer';
import BrandIcon from '../BrandIcon/BrandIcon';

type PropsType = {
  containerStyles?: any;
  selected: boolean;
  disabled?: boolean;
  onPress?: (arg: any) => void;
  title: string;
  BottomComponent?: any;
  higlighted?: boolean;
};

const CheckboxListItem: React.FC<PropsType> = ({
  containerStyles,
  selected,
  disabled,
  onPress,
  title,
  BottomComponent,
  higlighted,
}) => {
  return (
    <div
      className="checkbox-item"
      style={{
        ...containerStyles,
        ...(selected ? { backgroundColor: getLightBrandColor() } : {}),
      }}
    >
      <div
        className="checkbox-item-row"
        onClick={disabled ? () => {} : () => onPress(name)}
      >
        <BrandIcon
          name={
            selected
              ? 'selected'
              : disabled
              ? 'iconCheckboxDisabledGrey'
              : higlighted
              ? 'iconCheckboxHighlighted'
              : 'iconCheckboxInactive'
          }
          style={{ width: 24, height: 24 }}
        />
        <div
          className={
            higlighted
              ? 'checkbox-item-title-highlighted noselect'
              : 'checkbox-item-title noselect'
          }
        >
          {title}
        </div>
      </div>
      {BottomComponent}
    </div>
  );
};

export default CheckboxListItem;
